// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"5":"26be745f","606":"73af513a"}[chunkId] + ".js";
};